import { render, staticRenderFns } from "./UserDatasetTable.vue?vue&type=template&id=f451220a&"
import script from "./UserDatasetTable.vue?vue&type=script&lang=js&"
export * from "./UserDatasetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports